import { useCallback } from 'react';
import { useSendOnCopilotChannel } from '../channel/hooks/useSendOnCopilotChannel';
import type { OpenBreezeAssistantOptions } from '../types/Channel';

export const useOpenCopilot = () => {
  const openCopilot = useSendOnCopilotChannel('OPEN_COPILOT');

  return useCallback(
    (options?: OpenBreezeAssistantOptions) => {
      openCopilot(options);
    },
    [openCopilot]
  );
};
